import { Box, styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

import { WarningIndicator } from '@/components/notifications/WarningIndicator/WarningIndicator';

import {
  commonTabStyle,
  getActiveStyle,
  hoverStyle,
  inactiveStyle,
  TAB_BOTTOM_PADDING,
} from './Tabs.utils';

const inactiveOverrideStyle = {
  ...inactiveStyle,
  borderBottom: 'none',
  paddingBottom: `${TAB_BOTTOM_PADDING}px`,
};

const StyledNavLink = styled(NavLink)(({ theme }) => ({
  ...commonTabStyle,
  ...inactiveStyle,
  position: 'relative',
  textDecoration: 'none',
  cursor: 'pointer',

  '&:hover': hoverStyle,

  // route-based active (NavLink adds .active, incl. parent-on-child routes)
  '&.active': getActiveStyle('tab1', theme),
  '&[data-active="true"]': getActiveStyle('tab1', theme),

  // explicit inactive override — listed AFTER .active so it wins the equal-specificity
  // tie (e.g. the Documents tab while on the /documents/memos child route)
  '&[data-active="false"]': inactiveOverrideStyle,
  '&[data-active="false"]:hover': hoverStyle,
}));

export interface LinkTabProps {
  to: string;
  display: React.ReactNode;
  isActive?: boolean;
  showWarningBadge?: boolean;
  dataTestId?: string;
}

export function LinkTab({
  to,
  display,
  isActive: isActiveOverride,
  dataTestId,
  showWarningBadge,
}: LinkTabProps) {
  return (
    <StyledNavLink
      data-testid={dataTestId}
      to={to}
      data-active={
        isActiveOverride === undefined ? undefined : String(isActiveOverride)
      }
    >
      <Box display="flex" alignItems="center" gap={1}>
        {typeof display === 'string' ? (
          <Typography variant="body-xs" color="inherit">
            {display}
          </Typography>
        ) : (
          display
        )}
      </Box>
      {showWarningBadge && (
        <Box sx={{ position: 'absolute', top: -10, right: -10 }}>
          <WarningIndicator size={16} />
        </Box>
      )}
    </StyledNavLink>
  );
}
